export class HomeInspire {
  constructor(rootEl) {
    this.root = rootEl;

    this.trackScroll();
    this.trackReduceMotion();

    const rowConfigs = Array.from(this.root.querySelectorAll('.home__inspire-images')).map(
      (row, index) => this.getRowConfig(row, index),
    );

    this.animate(rowConfigs);
  }

  trackScroll() {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.body.scrollHeight;
      const maxScrollDistance = scrollHeight - window.innerHeight;
      this.scrollPercentage = scrollTop / maxScrollDistance;
    };

    onScroll();
    document.addEventListener('scroll', onScroll);
  }

  trackReduceMotion() {
    const onReduceMotionChange = event => {
      this.reduceMotion = event.matches;
    };

    onReduceMotionChange(window.matchMedia('(prefers-reduced-motion: reduce)'));
    window
      .matchMedia('(prefers-reduced-motion: reduce)')
      .addEventListener('change', onReduceMotionChange);
  }

  getRowConfig(rowEl, index) {
    const rowWidth = rowEl.offsetWidth;

    const trackEl = rowEl.querySelector('.home__inspire-images-inner');
    const trackWidth = trackEl.offsetWidth;

    const maxTranslateX = trackWidth - rowWidth;
    const multiplier = [-1, 0.75, -0.5][index % 3];

    return {
      trackEl,
      maxDelta: maxTranslateX * multiplier,
    };
  }

  animate(configs) {
    const update = () => {
      let scrollPercentage = this.scrollPercentage;
      if (this.reduceMotion) {
        scrollPercentage = 0.33;
      }

      configs.forEach(config => {
        const translateX = config.maxDelta * scrollPercentage;
        config.trackEl.style.transform = `translateX(${translateX}px)`;
      });

      requestAnimationFrame(update);
    };

    update();
  }
}
